import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '@core/ngrx/reducers/security.reducer';

export const selectSecurityState = createFeatureSelector<State>('security');

export const selectRoles = createSelector(selectSecurityState, (state) => state.roles);
export const selectPermissions = createSelector(selectSecurityState, (state) => state.permissions);

export const selectUserAccess = createSelector(selectSecurityState, (state) => ({
  roles: state.roles,
  permissions: state.permissions
}));
